"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("../constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var isDisconnected = function isDisconnected(message, name) {
  return [_constants.MESSAGES.PUBLISHER_DISCONNECTED(), _constants.MESSAGES.SUBSCRIBER_DISCONNECTED(name)].includes(message);
};
var PublisherMessage = function PublisherMessage(_ref) {
  var message = _ref.message,
    targetName = _ref.targetName;
  if (!message) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "message"
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    className: isDisconnected(targetName) ? 'icon-disconnect' : 'icon-video'
  }), /*#__PURE__*/_react.default.createElement("br", null), message);
};
var _default = PublisherMessage;
exports.default = _default;